<template>
  <div class="about-us">
    <div class="header-content">
      <h2 class="sub-title" v-if="isMobile">
        美業必備預約系統，預約排程、<br />會員經營、店務管理，<br />
        多種美業經營、行銷工具，<br />一套系統就能搞定！
      </h2>
      <h1 class="title">
        整合預約、經營功能<br />
        深受業界好評的預約系統
      </h1>
      <h2 class="sub-title" v-if="isDesktop">
        美業必備預約系統，預約排程、會員經營、店務管理，<br />
        多種美業經營、行銷工具，一套系統就能搞定！
      </h2>
      <button @click="toForm($route.name)">聯絡我們</button>
    </div>
  </div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core'
import { computed } from '@vue/reactivity'
import { toForm } from '@/utils/helper'
const { width } = useWindowSize()

const isDesktop = computed(() => {
  return width.value > 768
})
const isMobile = computed(() => {
  return width.value < 768
})
</script>

<style scoped lang="postcss">
.about-us {
  @apply h-[408px] rounded-bl-[80px] w-full;
  @apply md:(h-[611px]);
  @apply ipad:(h-[611px] rounded-bl-[150px]);
  background-image: url('@/assets/header/2025/about-us.webp'),
    url('@/assets/header/2025/about-us_bg.webp');

  @screen <ipad {
    @apply flex items-end;
    background-color: rgb(252 251 255);
    background-image: url('@/assets/header/2025/about-us_mobile.webp'),
      url('@/assets/header/2025/about-us_bg_mobile.webp');
  }
}

.header-content {
  @apply text-left text-primary-100 px-[136px] pt-[120px];
  @apply <desktop:(px-[50px]);
  @apply <ipad:(p-[50px]);
  @apply <tablet:(pl-[29px] pr-[10px] pb-[44px] pt-[0]);
}

button {
  @apply bg-secondary-100 text-white rounded-full;
  @apply px-[68px] py-[15px];
  @apply <ipad:(px-[20px] py-[6px] text-[16px]);
  @apply <tablet:(px-[20px] py-[6px] text-[16px]);
}

.title {
  @apply m-0 font-bold text-[60px] leading-[86.88px] tracking-[2px] mb-[25px];
  @apply <desktop:(text-[54px] leading-[86.88px])
  @apply <laptop:(text-[40px] leading-[1.5])
  @apply <ipad:(text-[30px] leading-[1.5] mb-[17px]);
  @apply <md:(text-[26px] leading-[1.5] mb-[17px]);
}

.sub-title {
  @apply font-medium text-[27.16px] leading-[40px] tracking-[1.51px] mb-[42px];
  @apply <desktop:(text-[25px] leading-[40px])
  @apply <laptop:(text-[22px] leading-[40px])
  @apply <ipad:(text-[19px] leading-[1.5] mb-[12px]);
  @apply <md:(text-[11px] leading-[1.5] mb-[17px]);
}
</style>
